/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportLogEntryStatus {
  Created = 0,
  Uploaded = 1,
  Waiting = 2,
  Stuck = 3,
  Accepted = 4,
  Failed = 5,
  CustomsRejected = 6,
  CustomsAccepted = 7,
  CustomsReleased = 8,
}
